import type { ConstValues } from '@openx/types/helpers.ts';
import type { Element, TargetingElementKeysType } from '../context/types.ts';

export const Operation = {
  SELECT: 'select',
  DESELECT: 'deselect',
  BLOCK: 'block',
  ENABLE: 'enable',
  BLOCK_SECTION: 'blockSection',
  ENABLE_SECTION: 'enableSection',
} as const;

export type OperationType = ConstValues<typeof Operation>;

export type SectionElementOperation = {
  type: OperationType;
  elementKey: TargetingElementKeysType | null;
};

type BaseElementHandlerType = (elements: Element[], key: TargetingElementKeysType | null) => Element[];

type ElementHandlerName = 'selectElementByKey' | 'deselectElementByKey' | 'disableElementByKey' | 'enableElementByKey';

type SectionHandlerName = 'blockSection' | 'enableSection';

type HandlerName = ElementHandlerName | SectionHandlerName;

export type SectionReducerInput = {
  elements: Element[];
  operation: SectionElementOperation;
  handlers: Record<HandlerName, BaseElementHandlerType>;
};
